export const PERMISSION_RESOURCE_CODES = {
  company: 'portfolio-company',
  governance: 'portfolio-governance',
  opportunity: 'portfolio-opportunity',
  report: 'portfolio-report',
} as const;

export const PERMISSION_ACTION_CODES = {
  company: {
    view: 'view',
    edit: 'edit',
    manage: 'manage',
  },
  governance: {
    view: 'view',
    edit: 'edit',
    manage: 'manage',
  },
  opportunity: {
    view: 'view',
    edit: 'edit',
    manage: 'manage',
  },
  report: {
    view: 'view',
    edit: 'edit',
    manage: 'manage',
  },
} as const;

export const buildPermissionKey = (resourceCode: string, actionCode: string) =>
  `${resourceCode}:${actionCode}`;

export const hasActionAccess = (
  access: Record<string, boolean | undefined>,
  resourceCode: string,
  actionCode: string,
) =>
  Boolean(
    access[buildPermissionKey(resourceCode, actionCode)] ??
      access[buildPermissionKey(resourceCode, 'manage')] ??
      access[`${resourceCode}:*`],
  );
